import { ImportFixDTO, ImportProtocolClient, ImportProtocolDTO, ImportSuccessState } from './../../../../base/models/models.swagger.generated';
import { tap, catchError, finalize } from 'rxjs';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ToastService } from 'src/app/base/services/toast.service';
import { SpinnerService } from 'src/app/base/spinner/spinner.service';

@Injectable({
  providedIn: 'root'
})
export class ImportConfigurationProtocolEditFormService {

  constructor(
    private protocolClient: ImportProtocolClient,
    private spinnerService: SpinnerService,
    private toastService: ToastService) { }

  public loadFullProtocol(protocolId: number, iteration: number): Observable<ImportProtocolDTO> {
    this.spinnerService.show();
    return this.protocolClient.getProtocol(protocolId, iteration).pipe(
      finalize(() => {
        this.spinnerService.hide();
      }),
      catchError((err) => {
        this.toastService.showError( 'i18n.domain.import-protocol.messages.load-full-protocol.title', 'i18n.domain.import-protocol.messages.load-full-protocol.error-text');
        throw err;
      })
    );
  }

  public import(data: ImportFixDTO): Observable<ImportProtocolDTO> {
    return this.protocolClient.import(data).pipe(
      tap((data: ImportProtocolDTO) => {
        if (data.successState !== ImportSuccessState.Error) {
          this.toastService.showSuccess( 'i18n.domain.import-protocol.messages.import.title', 'i18n.domain.import-protocol.messages.import.success-text');
          return;
        }
        this.toastService.showWarning( 'i18n.domain.import-protocol.messages.import.title', 'i18n.domain.import-protocol.messages.import.warning-text');
      }),
      catchError((err) => {
        this.toastService.showError( 'i18n.domain.import-protocol.messages.import.title', 'i18n.domain.import-protocol.messages.import.error-text');
        throw err;
      })
    )
  }

}
